import styled from 'styled-components';

import {rotate} from '../../styles/keyframes/keyframes';

export const Button = styled.button`
  background-color: ${props => props.theme.quaternaryBackground};
  color: ${props => props.theme.primaryColor};
  font-size: ${props => props.theme.fontSize};
  outline: none;
  cursor: pointer;
  border: 0;
  line-height: 1.8rem;
  padding: 1.2rem 2rem;
  text-transform: uppercase;
`;

export const Button1 = Button.extend`
  background-color: ${props => props.theme.primaryBackground};
  color: ${props => props.theme.secondaryColor};
`;

export const Button2 = styled.button`
  background-color: ${props => props.theme.secondaryColor};
  padding: ${props => props.theme.padding};
  font-size: ${props => props.theme.button.size};
  color: ${props => props.theme.primaryColor};
  border-radius: 5px;
  border: none;
  border-bottom: ${props => props.theme.button.primary.borderBottom};
  cursor: pointer;
  text-align: center;
  transition: background-color 0.2s;
  width: 100%;
  display: inline-block;
  text-transform: uppercase;
  outline: none;
  &:hover {
    background-color: ${props => props.theme.button.primary.hoverColor};
  }
  &:disabled {
    cursor: default;
    background-color: ${props => props.theme.disabledButtonBackground};
    border-bottom: ${props => props.theme.button.secondary.borderBottom};
  }
`;

export const Button2a = styled(Button2)`
  line-height: 1.6rem;
`;

export const Button3 = styled(Button2)`
  background-color: ${props => props.theme.primaryBackground};
  color: ${props => props.theme.secondaryColor};
  border-bottom: ${props => props.theme.button.secondary.borderBottom};
  &:hover {
    background-color: ${props => props.theme.button.secondary.hoverColor};
  }
`;

export const ButtonSpinner = styled.span`
  display: inline-block;
  height: 2.2rem;
  width: 2.2rem;
  position: relative;
  animation: ${rotate} 1s linear infinite;
  border-top: 0.6rem solid ${props => props.greySpinner ? '#e5e5e5' : props.theme.spinner.c1};
  border-right: 0.6rem solid ${props => props.greySpinner ? '#d1d1d1' : props.theme.spinner.c2};
  border-bottom: 0.6rem solid ${props => props.greySpinner ? '#b2b2b2' : props.theme.spinner.c3};
  border-left: 0.6rem solid ${props => props.greySpinner ? '#9b9b9b' : props.theme.spinner.c4};
  border-radius: 100%;
  margin: ${p => p.theme.spinner.margin};
`;

export const LightButton = styled.div`
  font-family: 'Montserrat', sans-serif;
  cursor: pointer;
  background: transparent;
  border: ${props => `0.3rem solid ${props.theme.primaryColor}`};
  font-size: 1.2rem;
  letter-spacing: 0.2rem;
  padding: 1rem 3rem;
  text-transform: uppercase;
  text-align: center;
  border-radius: 0.4rem;
  position: relative;
  display: inline-block;
  vertical-align: middle;
  transform: translateZ(0);
  backface-visibility: hidden;
  -moz-osx-font-smoothing: grayscale;
  transition: 0.4s;
  height: 100%;
  span {
    color: ${p => p.theme.primaryColor};
  }
  &::before {
    content: '';
    position: absolute;
    display: inline-block;
    z-index: -1;
    top: 0;
    left: 0;
    right: -0.1rem;
    bottom: -0.1rem;
    transform: scaleY(0);
    transform-origin: 50% 0;
    transition-property: transform;
    transition-duration: 0.3s;
    transition-timing-function: ease-out;
    background: ${props => props.theme.primaryColor};
  }
  &:hover {
    color: ${props => props.theme.secondaryColor};
    span {
      color: ${props => props.theme.secondaryColor};
    }
    &::before {
      transform: scaleY(1);
      transition-timing-function: cubic-bezier(0.54, 1.64, 0.37, 0.66);
      background-color: ${props => props.theme.primaryColor};
      margin-top: -0.1rem;
      margin-left: -0.1rem;
    }
  }
`;



// WEBPACK FOOTER //
// ./styles/components/button.style.js